import { render } from "./rkpd.vue?vue&type=template&id=31936ceb"
import script from "./rkpd.vue?vue&type=script&lang=js"
export * from "./rkpd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__